import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@teals/ui-web";
import type { McpIntegration } from "../../store/api/mcpIntegrationsApi";
import { mcpHost } from "../../store/api/mcpIntegrationsApi";
import { formatRelativeTime } from "../DataSources/relativeTime";
import {
  DSCard,
  CardHeader,
  CardTitle,
  CardRecords,
  AgentChipRow,
  AgentChip,
  CardFooter,
  MetaItem,
  MetaItemGrow,
  DividerDot,
} from "../DataSources/styles";

interface CustomMcpCardProps {
  mcp: McpIntegration;
  to: string;
  agentNames?: Record<string, string>;
}

const CustomMcpCard: React.FC<CustomMcpCardProps> = ({
  mcp,
  to,
  agentNames = {},
}) => {
  const agentChips = (mcp.agentIds || []).map((id) => ({
    id,
    label: agentNames[id] || id,
  }));
  const authLabel =
    mcp.authMode === "stored_credentials" ? "Stored credentials" : "Caller token";
  const verified = mcp.lastVerifiedAt
    ? formatRelativeTime(mcp.lastVerifiedAt).replace("synced", "verified")
    : "Not verified";

  const host = mcpHost(mcp.serverUrl) || "No host";

  return (
    <Link to={to}>
      <DSCard padding={20} elevation="sm" data-testid="custom-mcp-card">
        <CardHeader>
          <div>
            <CardTitle>{mcp.name}</CardTitle>
            <CardRecords>{host}</CardRecords>
          </div>
          <Badge variant="info" size="sm">
            Custom MCP
          </Badge>
        </CardHeader>
        {agentChips.length > 0 && (
          <AgentChipRow>
            {agentChips.slice(0, 4).map((chip) => (
              <AgentChip key={chip.id}>{chip.label}</AgentChip>
            ))}
            {agentChips.length > 4 && (
              <AgentChip>+{agentChips.length - 4}</AgentChip>
            )}
          </AgentChipRow>
        )}
        <CardFooter>
          <MetaItemGrow title={authLabel}>{authLabel}</MetaItemGrow>
          <DividerDot />
          <MetaItem>{verified}</MetaItem>
          <DividerDot />
          <MetaItem>Open →</MetaItem>
        </CardFooter>
      </DSCard>
    </Link>
  );
};

export default CustomMcpCard;
